// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"228":"f9b01a6e","884":"6013f808","951":"a80e4641"}[chunkId] + ".js";
};